import React from 'react';
import { Check, Minus } from 'lucide-react';
import { usdNum } from './PlanCardShell';

const FEATURES = [
  ['Round robin schedules', true, true, true],
  ['Teams per tournament', 'Up to 8', 'Unlimited', 'Unlimited'],
  ['PDF, Excel & iCal exports', 'Basic', 'Branded', 'Branded'],
  ['Single / double elimination, pools, hybrid, consolation', false, true, true],
  ['Printable brackets (PDF, SVG, PNG)', false, true, true],
  ['Season analytics, tie-breakers & leaderboards', false, true, true],
  ['Live stat tracking (5 sports)', false, true, true],
  ['AI schedule import & box-score scanning', false, true, true],
  ['Officials database, portal & availability', false, false, true],
  ['Assign officials with conflict & travel warnings', false, false, true],
  ['Assignment emails, 24h / 3h reminders', false, false, true],
  ['Pay rates, rate templates & payment tracking', false, false, true],
];

const priceRows = (pro, o) => [
  ['Price', '$0', `$${usdNum(pro.monthly)}/mo or $${usdNum(pro.annual)}/yr`, o ? `$${usdNum(o.annual.total)}/yr or $${usdNum(o.flex.total)} today, then $${usdNum(o.proMonthly)}/mo + $${usdNum(o.officials)}/yr` : '—'],
  ['First-year cost', '$0', `$${usdNum(pro.annual)} annual · $${usdNum(pro.monthly * 12)} monthly`, o ? `$${usdNum(o.annual.total)} annual · $${usdNum(o.firstYearFlex)} flexible` : '—'],
  ['Annual bundle saving', false, false, o ? `Save $${usdNum(o.save)} vs flexible` : '—'],
];

const Cell = ({ v, bundle }) => {
  if (v === true) return <Check className={`w-5 h-5 mx-auto ${bundle ? 'text-amber-500' : 'text-[#009E49]'}`} strokeWidth={3} />;
  if (v === false) return <Minus className="w-4 h-4 mx-auto text-slate-300" />;
  return <span className="text-xs sm:text-sm font-semibold text-slate-700">{v}</span>;
};

const Rows = ({ rows, group }) => (
  <>
    <tr className="bg-slate-50"><td colSpan={4} className="px-3 sm:px-6 py-2 text-[11px] font-bold uppercase tracking-wider text-slate-400">{group}</td></tr>
    {rows.map(([label, free, pro, bundle]) => (
      <tr key={label} className="border-t border-slate-100 hover:bg-slate-50/60 transition-colors">
        <td className="px-3 sm:px-6 py-3 text-xs sm:text-sm text-slate-800 font-medium">{label}</td>
        <td className="px-2 py-3 text-center"><Cell v={free} /></td>
        <td className="px-2 py-3 text-center"><Cell v={pro} /></td>
        <td className="px-2 py-3 text-center bg-amber-50/50"><Cell v={bundle} bundle /></td>
      </tr>
    ))}
  </>
);

export const PlanComparison = ({ pro, offer }) => (
  <section className="max-w-5xl mx-auto mb-12" data-testid="plan-comparison">
    <h3 className="text-3xl font-black uppercase text-slate-900 mb-1" style={{ fontFamily: 'Barlow Condensed' }}>Compare all features</h3>
    <p className="text-slate-500 text-sm mb-5">Officials Scheduling is also sold on its own and works with Free or Pro.</p>
    <div className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
      <table className="w-full table-fixed text-left" data-testid="pricing-feature-comparison-table">
        <thead>
          <tr className="border-b border-slate-200">
            <th className="px-3 sm:px-6 py-4 text-xs uppercase tracking-wider text-slate-500 font-bold w-[40%]">Feature</th>
            <th className="px-2 py-4 text-center text-sm font-bold text-slate-700">Free</th>
            <th className="px-2 py-4 text-center text-sm font-bold text-[#00247D]">Pro</th>
            <th className="px-2 py-4 text-center text-sm font-bold text-amber-700 bg-amber-50/50" data-testid="comparison-bundle-col">
              <span className="hidden sm:inline">Pro + Officials</span><span className="sm:hidden">Bundle</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <Rows group="Features" rows={FEATURES} />
          <Rows group="Pricing" rows={priceRows(pro, offer)} />
        </tbody>
      </table>
    </div>
  </section>
);
